import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const LockIcon = (props: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <path
        stroke={theme.palette.action.active}
        strokeWidth={1.5}
        d="M15.9 10.6V7.3a3.9 3.9 0 0 0-7.8 0v3.3m-1.4 9h10.6a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1H6.7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1Z"
      />
    </svg>
  );
};
